/**
 * Created by Alican Köker on 2019-09-09.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {EdisonSoundConfig} from "../../EdisonSoundConfig";
import {EdisonFreespinMeter} from "./indicator/EdisonFreespinMeter";

export class EdisonMetersOverlay extends BaseView {

    private _meterArr:EdisonFreespinMeter[] = [];
    private _meterPositionsLandscape:number[][] = [[246, 96], [1028, 94], [1025, 250], [1025, 398], [245, 246], [245, 394]];
    private _meterPositionsPortrait:number[][] = [[633, 538], [642, 536], [380, 466], [904, 466], [370, 463], [893, 465]];
    private _meterPositions:number[][] = this._meterPositionsLandscape;
    private _indicatorColors:string[] = ["meterBlack", "meterWhite", "meterRed", "meterPurple", "meterBlue", "meterGreen"];

    private _metersBgSpineSprite:PIXI.Sprite;
    private _metersBgSpine:PIXI.spine.Spine;

    private _spineSprite:PIXI.Sprite;
    private _spineSpritePosition:number[] = [640, 320];
    private _spineSpritePositionLandscape:number[] = [640, 320];
    private _spineSpritePositionPortrait:number[] = [640, 120];

    private _portraitUpAnimName:string = "PortraitUp";
    private _landscapeUpAnimName:string = "LandscapeUp";
    private _currentMetersUpAnimationName:string = "LandscapeUp";

    private _portraitDownAnimName:string = "PortraitDown";
    private _landscapeDownAnimName:string = "LandscapeDown";
    private _currentMetersDownAnimationName:string = "LandscapeDown";

    private _orientation:Orientation = Orientation.LANDSCAPE;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._spineSprite = new PIXI.Sprite();
        this.initMetersBgSpine();
        this.initMeters();

    }

    protected onResize(resizeData:IResizeData):void {
        this.reposition(resizeData.orientation);
        this._orientation = resizeData.orientation;
    }

    private reposition(orientation:Orientation, init:Boolean = false):void {
        let meterScale:number = orientation === Orientation.LANDSCAPE ? 1 : .8;

        if((orientation !== this._orientation || init) && this._metersBgSpine)
            this.handleMetersBgSpineAnim(orientation, init);

        if(orientation === Orientation.LANDSCAPE) {
            this._meterPositions = this._meterPositionsLandscape;
            this._spineSpritePosition = this._spineSpritePositionLandscape;
        } else {
            this._meterPositions = this._meterPositionsPortrait;
            this._spineSpritePosition = this._spineSpritePositionPortrait;
        }

        for(let i:number = 0; i < 6; i++) {
            const meter:EdisonFreespinMeter = this._meterArr[i];

            meter.position.set(this._meterPositions[i][0], this._meterPositions[i][1]);
            meter.scale.set(meterScale);
            meter.setDirection(orientation);
            meter.handlePlusOneBgPosition(orientation);
        }
        this._spineSprite.position.set(this._spineSpritePosition[0], this._spineSpritePosition[1]);
    }


    private initMeters():void {
        //rest of the indicators
        for(let i:number = 0; i < 6; i++) {
            this._meterArr[i] = new EdisonFreespinMeter(i < 2 ? 10 : 8, this._indicatorColors[i]);
            this._meterArr[i].position.set(this._meterPositions[i][0], this._meterPositions[i][1]);
            this.addChild(this._meterArr[i]);
        }

        this.hideMeters();
    }

    private initMetersBgSpine():void {
        this._metersBgSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("meters"));
        this._metersBgSpineSprite = new PIXI.Sprite();
        this.addChild(this._metersBgSpineSprite);
    }

    public playInitMetersBgSpine(init:Boolean = false):void {
        this._metersBgSpineSprite.visible = true;

        this._metersBgSpine.state.clearTracks();
        this._metersBgSpine.skeleton.setToSetupPose();

        this._metersBgSpineSprite.removeChildren();
        this._metersBgSpineSprite.addChild(this._metersBgSpine);
        this.reposition(this._orientation, init);


        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._metersBgSpine.visible = true;
            this._metersBgSpine.state.setAnimation(0, this._currentMetersUpAnimationName, false);
        }, .2);
        tl.add(() => {
            this.showMetersOnIntro();
        }, .6);
    }

    public hideMetersLayout():void {
        this.hideMeters();

        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            let entry:PIXI.spine.core.TrackEntry = this._metersBgSpine.state.setAnimation(0, this._currentMetersDownAnimationName, false);
            entry.animationStart = 0;
        }, 2);
    }

    public hideMeters():void {
        const transitionDuration:number = .7;
        let tl:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < 6; i++) {
            tl.add(() => {
                TweenLite.to(this._meterArr[i], transitionDuration, {alpha : 0});
            });
            tl.add(() => {
                TweenLite.to(this._meterArr[i], 0, {alpha : 1, visible : false});
            }, transitionDuration);
        }
    }

    public deactivateView():TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this.resetView();
        });
        tl.add(() => {
            this.hideMetersLayout();
        }, 1.5);
        tl.add(() => {
            if(this._orientation === Orientation.PORTRAIT) {
                TweenLite.to(this._metersBgSpine, 1, {y : this._spineSpritePosition[1] - 300});
                TweenLite.to(this._metersBgSpine, 0.1, {visible : false});
            }
        }, 4);
        tl.add(() => {
            this._metersBgSpineSprite.visible = false;
        }, 5);

        return tl;
    }


    public resetView():void {
        for(let i:number = 0; i < this._meterArr.length; i++) {
            this._meterArr[i].resetValue();
            this._meterArr[i].updateMeterVisual();
            this._meterArr[i].drainMeter();
        }
    }

    private handleMetersBgSpineAnim(orientation:Orientation, init:Boolean = false):void {
        this._currentMetersUpAnimationName = orientation === Orientation.LANDSCAPE ? this._landscapeUpAnimName : this._portraitUpAnimName;
        this._currentMetersDownAnimationName = orientation === Orientation.LANDSCAPE ? this._landscapeDownAnimName : this._portraitDownAnimName;

        let spineAnimY:number = orientation === Orientation.PORTRAIT ? 209 : 314;
        this._metersBgSpine.position.set(635, spineAnimY);
        if(!init) {
            let startingFrame:number = orientation === Orientation.LANDSCAPE ? 38 : 30;

            let entry:PIXI.spine.core.TrackEntry = this._metersBgSpine.state.setAnimation(0, this._currentMetersUpAnimationName, false);
            entry.timeScale = 0;

            entry.trackTime = Math.abs(startingFrame / 30);//30 fps
        }
    }

    private activateMeterGroup(meterIndexes:number[], interval:number, soundEffectIndex:number = 0):void {
        this._meterArr[meterIndexes[0]].visible = true;
        this._meterArr[meterIndexes[1]].visible = true;
        TweenLite.to(this._meterArr[meterIndexes[0]], interval, {alpha : 1});
        TweenLite.to(this._meterArr[meterIndexes[1]], interval, {alpha : 1});
        if(soundEffectIndex > 0)
            SlotGame.sound.playEffect((<any>EdisonSoundConfig.instance)[`FS_METER_APPEAR_${soundEffectIndex}`]);
    }

    public updateMeterValues(values:number[]):TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        if(!this._meterArr[0])
            return tl;

        //update meters
        for(let i:number = 0; i < values.length; i++) {
            tl.add(() => {
                this.updateMeter(i, values[i]);
            });
        }

        return tl;
    }

    public updateMeter(indicatorIndex:number, value:number):TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._meterArr[indicatorIndex].updateMeter(value);
        });
        return tl;
    }

    public showMetersOnIntro():void {
        let interval:number = .3;
        this._meterArr.forEach(meter => meter.alpha = 0);
        const isLandscape:boolean = this._orientation === Orientation.LANDSCAPE;
        const meterIndexes:number[][] = isLandscape ? [[0, 1], [2, 4], [3, 5]] : [[0, 1], [2, 3], [4, 5]];

        let tl:TimelineLite = new TimelineLite();

        for(let i:number = 0; i < 3; i++)
            tl.add(() => {
                this.activateMeterGroup(meterIndexes[i], interval, i + 1);
            }, interval * (i + 1));
    }

    public meterCap(meterIndex:number):number {
        return this._meterArr[meterIndex].cap;
    }

    public playInitMetersAnimations(init:Boolean):void {
        this.playInitMetersBgSpine(init);
        this.handleMetersBgSpineAnim(this._orientation, init);
    }


    public resetMeterLights(meterIndex:number):void {
        this._meterArr[meterIndex].resetMeterLight();
    }

    public resetMeterBgSequence(meterIndex:number):void {
        this._meterArr[meterIndex].playEndBlinkNumberBgSequence();
    }

}